function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m418.889 202.296v-41.185c0-88.831-72.28-161.111-161.111-161.111s-161.111 72.28-161.111 161.111v41.185c-19.169 11.177-32.222 31.731-32.222 55.482v193.333c0 35.542 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.902 64.444-64.444v-193.333c0-23.752-13.053-44.306-32.222-55.482zm-161.111-137.852c53.305 0 96.667 43.361 96.667 96.667v32.222h-193.334v-32.222c0-53.305 43.362-96.667 96.667-96.667zm32.222 309.679v44.766h-64.444v-44.766c-9.822-8.846-16.111-21.531-16.111-35.79 0-26.694 21.639-48.333 48.333-48.333s48.333 21.639 48.333 48.333c0 14.259-6.289 26.944-16.111 35.79z"
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 515.556 515.556",
    viewBox: "0 0 515.556 515.556",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.26479207.svg";
export { ForwardRef as ReactComponent };